
import React from "react"
import styled, { css } from "styled-components"
import { space, color, layout, system } from "styled-system"

import Alerta from "./svg/Alerta.svg"
import AccessApi from "./svg/access-api.svg"
import Api from "./svg/api.svg"
import ArrowBottom from "./svg/arrow-bottom.svg"
import ArrowLeft from "./svg/arrow-left.svg"
import ArrowRight from "./svg/arrow-right.svg"
import ArrowTop from "./svg/arrow-top.svg"
import Arrow from "./svg/arrow.svg"
import Bitbucket from "./svg/bitbucket.svg"
import Book from "./svg/book.svg"
import Calendar from "./svg/calendar.svg"
import Chart from "./svg/chart.svg"
import ClockBlack from "./svg/clock-black.svg"
import Clock from "./svg/clock.svg"
import Dashboard from "./svg/dashboard.svg"
import DataIco from "./svg/data-ico.svg"
import Download from "./svg/download.svg"
import File from "./svg/file.svg"
import Folder from "./svg/folder.svg"
import GatsbyLogo from "./svg/gatsby-logo.svg"
import Github from "./svg/github.svg"
import Home from "./svg/home.svg"
import InfoIco from "./svg/info-ico.svg"
import Link from "./svg/link.svg"
import LogoAniBlack from "./svg/logo-ani-black.svg"
import LogoAniWhite from "./svg/logo-ani-white.svg"
import LogoAnimadoBlanco from "./svg/logo-animado-blanco.svg"
import LogoAnimadoNegro from "./svg/logo-animado-negro.svg"
import LogoBlack from "./svg/logo-black.svg"
import LogoWhite from "./svg/logo-white.svg"
import MagmaLogo from "./svg/magma-logo.svg"
import MenuClose from "./svg/menu-close.svg"
import MenuOpen from "./svg/menu-open.svg"
import RemoteIco from "./svg/remote-ico.svg"
import Repor from "./svg/repor.svg"
import SymptonsCough from "./svg/symptons-cough.svg"
import SymptonsDiabetes from "./svg/symptons-diabetes.svg"
import SymptonsExpectoration from "./svg/symptons-expectoration.svg"
import SymptonsFever from "./svg/symptons-fever.svg"
import SymptonsHeart from "./svg/symptons-heart.svg"
import SymptonsHospital from "./svg/symptons-hospital.svg"
import SymptonsHypertension from "./svg/symptons-hypertension.svg"
import SymptonsQuarantine from "./svg/symptons-quarantine.svg"
import SymptonsUnwell from "./svg/symptons-unwell.svg"
import SymtonsCough from "./svg/symtons-cough.svg"
import Vector from "./svg/vector.svg"
import VirusCough from "./svg/virus-cough.svg"
import VirusFever from "./svg/virus-fever.svg"
import VirusGreenIco from "./svg/virus-green-ico.svg"
import VirusIco from "./svg/virus-ico.svg"
import VirusIncubation from "./svg/virus-incubation.svg"
import VirusInfected3079 from "./svg/virus-infected-30-79.svg"
import VirusInfectedMen from "./svg/virus-infected-men.svg"
import VirusInfectedUnder20 from "./svg/virus-infected-under-20.svg"
import VirusInfected from "./svg/virus-infected.svg"
import VirusLungDamage from "./svg/virus-lung-damage.svg"
import VirusSoreThroath from "./svg/virus-sore-throath.svg"
import VirusSymptoms from "./svg/virus-symptoms.svg"
import VirusWhiteIco from "./svg/virus-white-ico.svg"

const Base = css`
  ${space}
  ${color}
  ${layout}
  * {
    ${system({
      fill: {
        property: "fill",
        scale: "color",
      },
    })}
  }
`


const BaseAlerta = styled(Alerta)`${Base}`
const BaseAccessApi = styled(AccessApi)`${Base}`
const BaseApi = styled(Api)`${Base}`
const BaseArrowBottom = styled(ArrowBottom)`${Base}`
const BaseArrowLeft = styled(ArrowLeft)`${Base}`
const BaseArrowRight = styled(ArrowRight)`${Base}`
const BaseArrowTop = styled(ArrowTop)`${Base}`
const BaseArrow = styled(Arrow)`${Base}`
const BaseBitbucket = styled(Bitbucket)`${Base}`
const BaseBook = styled(Book)`${Base}`
const BaseCalendar = styled(Calendar)`${Base}`
const BaseChart = styled(Chart)`${Base}`
const BaseClockBlack = styled(ClockBlack)`${Base}`
const BaseClock = styled(Clock)`${Base}`
const BaseDashboard = styled(Dashboard)`${Base}`
const BaseDataIco = styled(DataIco)`${Base}`
const BaseDownload = styled(Download)`${Base}`
const BaseFile = styled(File)`${Base}`
const BaseFolder = styled(Folder)`${Base}`
const BaseGatsbyLogo = styled(GatsbyLogo)`${Base}`
const BaseGithub = styled(Github)`${Base}`
const BaseHome = styled(Home)`${Base}`
const BaseInfoIco = styled(InfoIco)`${Base}`
const BaseLink = styled(Link)`${Base}`
const BaseLogoAniBlack = styled(LogoAniBlack)`${Base}`
const BaseLogoAniWhite = styled(LogoAniWhite)`${Base}`
const BaseLogoAnimadoBlanco = styled(LogoAnimadoBlanco)`${Base}`
const BaseLogoAnimadoNegro = styled(LogoAnimadoNegro)`${Base}`
const BaseLogoBlack = styled(LogoBlack)`${Base}`
const BaseLogoWhite = styled(LogoWhite)`${Base}`
const BaseMagmaLogo = styled(MagmaLogo)`${Base}`
const BaseMenuClose = styled(MenuClose)`${Base}`
const BaseMenuOpen = styled(MenuOpen)`${Base}`
const BaseRemoteIco = styled(RemoteIco)`${Base}`
const BaseRepor = styled(Repor)`${Base}`
const BaseSymptonsCough = styled(SymptonsCough)`${Base}`
const BaseSymptonsDiabetes = styled(SymptonsDiabetes)`${Base}`
const BaseSymptonsExpectoration = styled(SymptonsExpectoration)`${Base}`
const BaseSymptonsFever = styled(SymptonsFever)`${Base}`
const BaseSymptonsHeart = styled(SymptonsHeart)`${Base}`
const BaseSymptonsHospital = styled(SymptonsHospital)`${Base}`
const BaseSymptonsHypertension = styled(SymptonsHypertension)`${Base}`
const BaseSymptonsQuarantine = styled(SymptonsQuarantine)`${Base}`
const BaseSymptonsUnwell = styled(SymptonsUnwell)`${Base}`
const BaseSymtonsCough = styled(SymtonsCough)`${Base}`
const BaseVector = styled(Vector)`${Base}`
const BaseVirusCough = styled(VirusCough)`${Base}`
const BaseVirusFever = styled(VirusFever)`${Base}`
const BaseVirusGreenIco = styled(VirusGreenIco)`${Base}`
const BaseVirusIco = styled(VirusIco)`${Base}`
const BaseVirusIncubation = styled(VirusIncubation)`${Base}`
const BaseVirusInfected3079 = styled(VirusInfected3079)`${Base}`
const BaseVirusInfectedMen = styled(VirusInfectedMen)`${Base}`
const BaseVirusInfectedUnder20 = styled(VirusInfectedUnder20)`${Base}`
const BaseVirusInfected = styled(VirusInfected)`${Base}`
const BaseVirusLungDamage = styled(VirusLungDamage)`${Base}`
const BaseVirusSoreThroath = styled(VirusSoreThroath)`${Base}`
const BaseVirusSymptoms = styled(VirusSymptoms)`${Base}`
const BaseVirusWhiteIco = styled(VirusWhiteIco)`${Base}`

const StyledAlerta = ({...props}) => {
      return <BaseAlerta {...props} />
    }
const StyledAccessApi = ({...props}) => {
      return <BaseAccessApi {...props} />
    }
const StyledApi = ({...props}) => {
      return <BaseApi {...props} />
    }
const StyledArrowBottom = ({...props}) => {
      return <BaseArrowBottom {...props} />
    }
const StyledArrowLeft = ({...props}) => {
      return <BaseArrowLeft {...props} />
    }
const StyledArrowRight = ({...props}) => {
      return <BaseArrowRight {...props} />
    }
const StyledArrowTop = ({...props}) => {
      return <BaseArrowTop {...props} />
    }
const StyledArrow = ({...props}) => {
      return <BaseArrow {...props} />
    }
const StyledBitbucket = ({...props}) => {
      return <BaseBitbucket {...props} />
    }
const StyledBook = ({...props}) => {
      return <BaseBook {...props} />
    }
const StyledCalendar = ({...props}) => {
      return <BaseCalendar {...props} />
    }
const StyledChart = ({...props}) => {
      return <BaseChart {...props} />
    }
const StyledClockBlack = ({...props}) => {
      return <BaseClockBlack {...props} />
    }
const StyledClock = ({...props}) => {
      return <BaseClock {...props} />
    }
const StyledDashboard = ({...props}) => {
      return <BaseDashboard {...props} />
    }
const StyledDataIco = ({...props}) => {
      return <BaseDataIco {...props} />
    }
const StyledDownload = ({...props}) => {
      return <BaseDownload {...props} />
    }
const StyledFile = ({...props}) => {
      return <BaseFile {...props} />
    }
const StyledFolder = ({...props}) => {
      return <BaseFolder {...props} />
    }
const StyledGatsbyLogo = ({...props}) => {
      return <BaseGatsbyLogo {...props} />
    }
const StyledGithub = ({...props}) => {
      return <BaseGithub {...props} />
    }
const StyledHome = ({...props}) => {
      return <BaseHome {...props} />
    }
const StyledInfoIco = ({...props}) => {
      return <BaseInfoIco {...props} />
    }
const StyledLink = ({...props}) => {
      return <BaseLink {...props} />
    }
const StyledLogoAniBlack = ({...props}) => {
      return <BaseLogoAniBlack {...props} />
    }
const StyledLogoAniWhite = ({...props}) => {
      return <BaseLogoAniWhite {...props} />
    }
const StyledLogoAnimadoBlanco = ({...props}) => {
      return <BaseLogoAnimadoBlanco {...props} />
    }
const StyledLogoAnimadoNegro = ({...props}) => {
      return <BaseLogoAnimadoNegro {...props} />
    }
const StyledLogoBlack = ({...props}) => {
      return <BaseLogoBlack {...props} />
    }
const StyledLogoWhite = ({...props}) => {
      return <BaseLogoWhite {...props} />
    }
const StyledMagmaLogo = ({...props}) => {
      return <BaseMagmaLogo {...props} />
    }
const StyledMenuClose = ({...props}) => {
      return <BaseMenuClose {...props} />
    }
const StyledMenuOpen = ({...props}) => {
      return <BaseMenuOpen {...props} />
    }
const StyledRemoteIco = ({...props}) => {
      return <BaseRemoteIco {...props} />
    }
const StyledRepor = ({...props}) => {
      return <BaseRepor {...props} />
    }
const StyledSymptonsCough = ({...props}) => {
      return <BaseSymptonsCough {...props} />
    }
const StyledSymptonsDiabetes = ({...props}) => {
      return <BaseSymptonsDiabetes {...props} />
    }
const StyledSymptonsExpectoration = ({...props}) => {
      return <BaseSymptonsExpectoration {...props} />
    }
const StyledSymptonsFever = ({...props}) => {
      return <BaseSymptonsFever {...props} />
    }
const StyledSymptonsHeart = ({...props}) => {
      return <BaseSymptonsHeart {...props} />
    }
const StyledSymptonsHospital = ({...props}) => {
      return <BaseSymptonsHospital {...props} />
    }
const StyledSymptonsHypertension = ({...props}) => {
      return <BaseSymptonsHypertension {...props} />
    }
const StyledSymptonsQuarantine = ({...props}) => {
      return <BaseSymptonsQuarantine {...props} />
    }
const StyledSymptonsUnwell = ({...props}) => {
      return <BaseSymptonsUnwell {...props} />
    }
const StyledSymtonsCough = ({...props}) => {
      return <BaseSymtonsCough {...props} />
    }
const StyledVector = ({...props}) => {
      return <BaseVector {...props} />
    }
const StyledVirusCough = ({...props}) => {
      return <BaseVirusCough {...props} />
    }
const StyledVirusFever = ({...props}) => {
      return <BaseVirusFever {...props} />
    }
const StyledVirusGreenIco = ({...props}) => {
      return <BaseVirusGreenIco {...props} />
    }
const StyledVirusIco = ({...props}) => {
      return <BaseVirusIco {...props} />
    }
const StyledVirusIncubation = ({...props}) => {
      return <BaseVirusIncubation {...props} />
    }
const StyledVirusInfected3079 = ({...props}) => {
      return <BaseVirusInfected3079 {...props} />
    }
const StyledVirusInfectedMen = ({...props}) => {
      return <BaseVirusInfectedMen {...props} />
    }
const StyledVirusInfectedUnder20 = ({...props}) => {
      return <BaseVirusInfectedUnder20 {...props} />
    }
const StyledVirusInfected = ({...props}) => {
      return <BaseVirusInfected {...props} />
    }
const StyledVirusLungDamage = ({...props}) => {
      return <BaseVirusLungDamage {...props} />
    }
const StyledVirusSoreThroath = ({...props}) => {
      return <BaseVirusSoreThroath {...props} />
    }
const StyledVirusSymptoms = ({...props}) => {
      return <BaseVirusSymptoms {...props} />
    }
const StyledVirusWhiteIco = ({...props}) => {
      return <BaseVirusWhiteIco {...props} />
    }

const Icons = {
alerta : StyledAlerta,
accessApi : StyledAccessApi,
api : StyledApi,
arrowBottom : StyledArrowBottom,
arrowLeft : StyledArrowLeft,
arrowRight : StyledArrowRight,
arrowTop : StyledArrowTop,
arrow : StyledArrow,
bitbucket : StyledBitbucket,
book : StyledBook,
calendar : StyledCalendar,
chart : StyledChart,
clockBlack : StyledClockBlack,
clock : StyledClock,
dashboard : StyledDashboard,
dataIco : StyledDataIco,
download : StyledDownload,
file : StyledFile,
folder : StyledFolder,
gatsbyLogo : StyledGatsbyLogo,
github : StyledGithub,
home : StyledHome,
infoIco : StyledInfoIco,
link : StyledLink,
logoAniBlack : StyledLogoAniBlack,
logoAniWhite : StyledLogoAniWhite,
logoAnimadoBlanco : StyledLogoAnimadoBlanco,
logoAnimadoNegro : StyledLogoAnimadoNegro,
logoBlack : StyledLogoBlack,
logoWhite : StyledLogoWhite,
magmaLogo : StyledMagmaLogo,
menuClose : StyledMenuClose,
menuOpen : StyledMenuOpen,
remoteIco : StyledRemoteIco,
repor : StyledRepor,
symptonsCough : StyledSymptonsCough,
symptonsDiabetes : StyledSymptonsDiabetes,
symptonsExpectoration : StyledSymptonsExpectoration,
symptonsFever : StyledSymptonsFever,
symptonsHeart : StyledSymptonsHeart,
symptonsHospital : StyledSymptonsHospital,
symptonsHypertension : StyledSymptonsHypertension,
symptonsQuarantine : StyledSymptonsQuarantine,
symptonsUnwell : StyledSymptonsUnwell,
symtonsCough : StyledSymtonsCough,
vector : StyledVector,
virusCough : StyledVirusCough,
virusFever : StyledVirusFever,
virusGreenIco : StyledVirusGreenIco,
virusIco : StyledVirusIco,
virusIncubation : StyledVirusIncubation,
virusInfected3079 : StyledVirusInfected3079,
virusInfectedMen : StyledVirusInfectedMen,
virusInfectedUnder20 : StyledVirusInfectedUnder20,
virusInfected : StyledVirusInfected,
virusLungDamage : StyledVirusLungDamage,
virusSoreThroath : StyledVirusSoreThroath,
virusSymptoms : StyledVirusSymptoms,
virusWhiteIco : StyledVirusWhiteIco,
}

const IcnSystem = ({ name, ...props }) => {
  return Icons[name](props)
}

export { StyledAlerta as Alerta }
export { StyledAccessApi as AccessApi }
export { StyledApi as Api }
export { StyledArrowBottom as ArrowBottom }
export { StyledArrowLeft as ArrowLeft }
export { StyledArrowRight as ArrowRight }
export { StyledArrowTop as ArrowTop }
export { StyledArrow as Arrow }
export { StyledBitbucket as Bitbucket }
export { StyledBook as Book }
export { StyledCalendar as Calendar }
export { StyledChart as Chart }
export { StyledClockBlack as ClockBlack }
export { StyledClock as Clock }
export { StyledDashboard as Dashboard }
export { StyledDataIco as DataIco }
export { StyledDownload as Download }
export { StyledFile as File }
export { StyledFolder as Folder }
export { StyledGatsbyLogo as GatsbyLogo }
export { StyledGithub as Github }
export { StyledHome as Home }
export { StyledInfoIco as InfoIco }
export { StyledLink as Link }
export { StyledLogoAniBlack as LogoAniBlack }
export { StyledLogoAniWhite as LogoAniWhite }
export { StyledLogoAnimadoBlanco as LogoAnimadoBlanco }
export { StyledLogoAnimadoNegro as LogoAnimadoNegro }
export { StyledLogoBlack as LogoBlack }
export { StyledLogoWhite as LogoWhite }
export { StyledMagmaLogo as MagmaLogo }
export { StyledMenuClose as MenuClose }
export { StyledMenuOpen as MenuOpen }
export { StyledRemoteIco as RemoteIco }
export { StyledRepor as Repor }
export { StyledSymptonsCough as SymptonsCough }
export { StyledSymptonsDiabetes as SymptonsDiabetes }
export { StyledSymptonsExpectoration as SymptonsExpectoration }
export { StyledSymptonsFever as SymptonsFever }
export { StyledSymptonsHeart as SymptonsHeart }
export { StyledSymptonsHospital as SymptonsHospital }
export { StyledSymptonsHypertension as SymptonsHypertension }
export { StyledSymptonsQuarantine as SymptonsQuarantine }
export { StyledSymptonsUnwell as SymptonsUnwell }
export { StyledSymtonsCough as SymtonsCough }
export { StyledVector as Vector }
export { StyledVirusCough as VirusCough }
export { StyledVirusFever as VirusFever }
export { StyledVirusGreenIco as VirusGreenIco }
export { StyledVirusIco as VirusIco }
export { StyledVirusIncubation as VirusIncubation }
export { StyledVirusInfected3079 as VirusInfected3079 }
export { StyledVirusInfectedMen as VirusInfectedMen }
export { StyledVirusInfectedUnder20 as VirusInfectedUnder20 }
export { StyledVirusInfected as VirusInfected }
export { StyledVirusLungDamage as VirusLungDamage }
export { StyledVirusSoreThroath as VirusSoreThroath }
export { StyledVirusSymptoms as VirusSymptoms }
export { StyledVirusWhiteIco as VirusWhiteIco }

export const iconList = [
  "Alerta","AccessApi","Api","ArrowBottom","ArrowLeft","ArrowRight","ArrowTop","Arrow","Bitbucket","Book","Calendar","Chart","ClockBlack","Clock","Dashboard","DataIco","Download","File","Folder","GatsbyLogo","Github","Home","InfoIco","Link","LogoAniBlack","LogoAniWhite","LogoAnimadoBlanco","LogoAnimadoNegro","LogoBlack","LogoWhite","MagmaLogo","MenuClose","MenuOpen","RemoteIco","Repor","SymptonsCough","SymptonsDiabetes","SymptonsExpectoration","SymptonsFever","SymptonsHeart","SymptonsHospital","SymptonsHypertension","SymptonsQuarantine","SymptonsUnwell","SymtonsCough","Vector","VirusCough","VirusFever","VirusGreenIco","VirusIco","VirusIncubation","VirusInfected3079","VirusInfectedMen","VirusInfectedUnder20","VirusInfected","VirusLungDamage","VirusSoreThroath","VirusSymptoms","VirusWhiteIco"
]

export default IcnSystem
 